module.exports = __webpack_public_path__ + "assets/img/ma-logo-cf9ffb88.png";